interface InitialNoteDialogResult {
  handled: true
  noteId: string | null
}

type NoteDialogSearchParams = Pick<URLSearchParams, "get">

export function consumeInitialNoteDialog(
  alreadyHandled: boolean,
  searchParams: NoteDialogSearchParams
): InitialNoteDialogResult {
  if (alreadyHandled) return { handled: true, noteId: null }

  const dialog = searchParams.get("dialog")
  const noteId = searchParams.get("id")

  return {
    handled: true,
    noteId: dialog === "note" && noteId ? noteId : null,
  }
}

export function shouldWriteNoteDialogQuery(searchParams: NoteDialogSearchParams, noteId: string): boolean {
  return searchParams.get("dialog") !== "note" || searchParams.get("id") !== noteId
}
